<template>
  <p class="ren-decoration-cp ren-decoration-cp-content-body">{{ plainText }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const plainText = computed(() =>
  stringValue(data.value.html ?? data.value.content ?? data.value.body, '暂无正文')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)
</script>
